import {Component} from '@angular/core';
import {DxDataGridModule, DxFormModule, DxTemplateDirective} from 'devextreme-angular';
import {NgClass} from "@angular/common";
import {
    ImportFileType,
    FileImportGridViewDto,
    FileImportStatus
} from "@services";
import EnumUtils from "../../../shared/enum-utils";
import {FilterPanelComponent} from "../../../components/library/filter-panel/filter-panel.component";
import {FilterConfig, GridPageComponent} from "../../common/grid-page.component";
import {UserAvatarEmailComponent} from "../../../components/utils/user-avatar-email/user-avatar-email.component";
import {PopupMessageComponent} from "../../../components/library/popup-message/popup-message.component";
import {DxDataGridTypes} from "devextreme-angular/ui/data-grid";
import {SignedLinkDirective} from 'src/app/directives/signed-link.directive';

@Component({
    selector: 'app-file-import-list',
    templateUrl: './file-import-list.component.html',
    styleUrls: ['./file-import-list.component.scss'],
    standalone: true,
    imports: [
        DxDataGridModule,
        DxTemplateDirective,
        NgClass,
        FilterPanelComponent,
        DxFormModule,
        UserAvatarEmailComponent,
        PopupMessageComponent,
        SignedLinkDirective
    ]
})
export class FileImportListComponent extends GridPageComponent<FileImportGridViewDto> {
    fileTypeOptions = EnumUtils.getEnumOptions(ImportFileType);
    statusOptions = EnumUtils.getEnumOptions(FileImportStatus);

    messagePopupTitle = '';
    messagePopupMessage: any = '';
    isErrorPopup = false;

    constructor() {
        super();
        this.init(FileImportGridViewDto);
    }

    dataSource = this.dataSources.fileImports();

    protected override exportName: string = "FileImports";
    protected readonly FileImportStatus = FileImportStatus;

    override nameOrEmailFilter = (filterValue: any, selectedFilterOperation: string) => {
        if (!filterValue) {
            return null;
        }

        return [
            ['createdByName', selectedFilterOperation || 'contains', filterValue],
            'or',
            ['createdByEmail', selectedFilterOperation || 'contains', filterValue]
        ];
    };

    protected override filterConfig: FilterConfig[] = [
        { field: 'fileName', op: 'contains' },
        { field: 'fileType', op: '=' },
        { field: 'status', op: '=' },
        { field: 'message', op: 'contains' },
        { field: 'lastModified', op: '>=' },
        { field: 'created', op: '>=' },
        { field: 'createdByName', op: 'contains', customFilter: this.nameOrEmailFilter }
    ];

    override onRowDblClick(e: DxDataGridTypes.RowDblClickEvent) {
        if (e.data && e.data.message) {
            const failed = e.data.status === FileImportStatus.Failed;
            this.messagePopupTitle = failed ? 'Import Error' : 'Import Summary';
            this.messagePopupMessage = e.data.message;
            this.isErrorPopup = failed;
            super.onRowDblClick(e);
        }
    }
}
